var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"linkClick"},[_c('el-link',{attrs:{"type":_vm.tableData.style || 'primary',"underline":false,"disabled":_vm.tableData.disabled && _vm.tableData.disabled(_vm.scope, _vm.tableData)},on:{"click":function($event){return _vm.click(_vm.tableData)}}},[_vm._v(_vm._s(_vm.scope.row[_vm.tableData.bind]))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }